export default __webpack_public_path__ + "static/media/caribainterview.1f68ffc7.png";